import React, { useState, useCallback, useEffect } from 'react';
import tenantsService from 'src/services/tenantService';
import useIsMountedRef from 'src/hooks/useIsMountedRef';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
	img: {
		width: '100%'
	}
}));

function Logo({ size, src, ...props }) {
	const classes = useStyles();
	const isMountedRef = useIsMountedRef();
	const [logo, setLogo] = useState(null);

	const getLogo = useCallback(() => {
		if (localStorage.getItem('LOGO')) {
			const logoStorage = JSON.parse(atob(localStorage.getItem('LOGO')));
			setLogo(logoStorage);
		}
	}, [isMountedRef]);

	useEffect(() => {
		if (src == null) {
			getLogo();
		} else {
			setLogo(src);
		}
	}, [getLogo, src]);

	if (!logo) return null;

	return <img alt="Logo" src={logo} className={classes.img} {...props} />;
}

export default Logo;
